import React, {useEffect, useState} from 'react';
import {VerifyIdentityPopupProps} from "../../models";
import {Button, Col, Drawer, Flex, Form, Input, message, Row} from "antd";
import Paragraph from "antd/es/typography/Paragraph";
import style from "./VerifyIdentity.module.scss";
import {connect, useSelector} from "react-redux";
import {RootState} from "../../../store/store";
import {verifyIdentity} from "../../actions";
import {withRouter} from "../../../utils/services/with-router";
import {useForm} from "antd/es/form/Form";
import TextArea from "antd/es/input/TextArea";

const VerifyIdentityPopup = ({open,onHandleOk,onHandleCancel,verifyIdentity} :VerifyIdentityPopupProps) => {
    const currentUser = useSelector((state: RootState) => state.currentUser.data.data);
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false)

    const onFinish = (value:any) => {
        setLoading(true)
        verifyIdentity(value)
            .then((data: any) => {
                setLoading(false)
                if (data.payload != undefined) {
                    if (data.payload.data) {
                        message.success('احزار هویت با موفقیت انجام شد')
                        onHandleOk()
                    } else message.error('احراز هویت موفقیت آمیز نبود')
                }
            })
            .catch((e: any) => {
            });
    };
    return (
        <Drawer
            height={"100%"}
            placement="bottom"
            open={open}
            onClose={onHandleCancel}
            title={"احراز هویت"}
            closable={true}
        >

            <Form layout={"vertical"} onFinish={onFinish} form={form}>
                <Flex justify={"center"}>
                    <img className={style.logoImg} src={require("assets/Logo/typographyPink.png")}/>
                </Flex>

                <Paragraph>
                برای جلوگیری از ورود شمارهٔ موبایل متخلف و افزایش سلامت تعاملات، تأیید هویت در پیدا انجام می‌شود.
                </Paragraph>
                <Paragraph>
                    {`حساب شما در پیدا با شمارهٔ ${currentUser?.mobileNumber} فعال است.`}
                </Paragraph>
                <h5 className={style.title}>
                    تأیید با کد ملی
                </h5>
                <Flex vertical>

                    <Form.Item label={'توجه: کد ملی شما به کاربران نمایش داده نمی‌شود.'} name={'nationalCode'}
                               rules={[
                                   {required: true, message: "کدملی را وارد کنید"},
                               ]}
                    >
                        <Input placeholder={"برای مثال : 4271473571"}/>
                    </Form.Item>
                    <Form.Item label={'نام و نام خانوادگی'} name={'fullName'}
                               rules={[
                                   {required: true, message: "نام و نام خانوادگی را وارد کنید"},
                               ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item label={'آدرس'} name={'address'}
                               rules={[
                                   {required: true, message: "آدرس را وارد کنید"},
                               ]}
                    >
                        <TextArea rows={3}/>
                    </Form.Item>

                    <Button loading={loading} block type={"primary"} htmlType={"submit"}>
                        انجام احراز هویت
                    </Button>
                </Flex>

            </Form>

        </Drawer>
    );
};

export default connect(null, {verifyIdentity})(withRouter(VerifyIdentityPopup));
